<template>
  <div
    class="content md no-padding niche-create-order"
    style="position: relative"
  >
    <div class="order-create-area">
      <NicheOrderForm
        :info="orderInfo"
        :step="1"
        ref="orderForm"
        v-show="step == 1"
      ></NicheOrderForm>
      <div class="order-create-preview" v-show="step == 2">
        <div class="other-title">支付信息</div>
        <div class="order-pay-info" v-if="order.detail">
          <div class="pay-info-piece">
            <div class="order-pay-title">
              <div class="pay-title-text">龛位</div>
              <div class="pay-title-value">
                {{ getShowPrice(order.detail.nichePrice) }}
              </div>
            </div>
            <div class="pay-info-item">
              <div class="pay-info-label">供奉位置</div>
              <div class="pay-info-value">{{ order.detail.showArea }}</div>
            </div>
            <div class="pay-info-item">
              <div class="pay-info-label">供奉时长</div>
              <div class="pay-info-value">{{ order.detail.showTime }}</div>
            </div>
          </div>
          <div class="pay-info-piece">
            <div class="order-pay-title">
              <div class="pay-title-text">供奉信息</div>
            </div>
            <div
              class="pay-info-item"
              v-for="(d, i) in order.detail.itemList"
              :key="i"
            >
              <div class="pay-info-label">{{ d.label }}</div>
              <div class="pay-info-value">{{ d.value }}</div>
            </div>
          </div>
          <div class="pay-info-piece">
            <div class="order-pay-title">
              <div class="pay-title-text">总金额</div>
              <div class="pay-title-value">
                {{ getShowPrice(order.detail.price) }}
              </div>
            </div>
          </div>
        </div>
        <NicheOrderForm :step="2" ref="previewForm"></NicheOrderForm>
      </div>
    </div>
    <a-space class="create-order-button">
      <a-button @click="cancel">取消</a-button>
      <a-button type="primary" @click="prev" v-show="step > 1">上一步</a-button>
      <a-button type="primary" @click="next" :loading="confirmLoading">
        {{ step == 2 ? "确定" : "下一步" }}
      </a-button>
    </a-space>
    <div class="order-niche-select" v-if="select">
      <span>已选</span>
      <div class="niche-select-info">
        <span>
          {{ select?.tabletRegion?.name }} {{ select?.tabletBlock?.name }}
          {{ select.num }}
        </span>
        <a-icon
          type="close"
          class="niche-select-remove"
          @click="removeSelect"
        />
      </div>
    </div>
  </div>
</template>

<script>
import NicheOrderForm from "./components/NicheOrderForm.vue";
import { getShowPrice, getIntegerAndDecimal } from "../../common/tablet/type";
import { omit } from "../../common/js/tool";
import { getUserWxId } from "../../common/js/storage";
import * as buddhism from "../../common/buddha/buddhism";

export default {
  name: "TabletOrderCreate",
  components: {
    NicheOrderForm,
  },
  data() {
    return {
      step: 1,
      select: null,
      order: {},
      oldOrder: null, // 续供订单
      confirmLoading: false,
    };
  },
  computed: {
    orderId() {
      const id = this.$route.query.o_id;
      return id ? Number(id) : 0;
    },
    // 续供TODO
    orderInfo() {
      const order = this.oldOrder;
      if (order) {
        return {
          // year_count: 10,
          // order_type: order.order_type,
          // name: order?.name,
          // mobile: order.mobile,
          // note: [order.type, order.note],
        };
      } else {
        return undefined;
      }
    },
  },
  watch: {
    orderId() {
      this.getOldOrder();
      this.step = 1;
    },
  },
  created() {
    this.getSelect();
    this.getOldOrder();
  },
  methods: {
    getShowPrice,
    getOldOrder() {
      const id = this.orderId;
      if (id) {
        const order = this.$store.getters.nicheOrder;
        if (order && order.id === id) {
          this.oldOrder = order;
        } else {
          this.$axios(`/admin/memorial-tablet-order/${id}`).then((res) => {
            this.oldOrder = res;
          });
        }
      } else {
        this.oldOrder = null;
      }
    },
    getSelect() {
      const id = this.$route.query.select;
      if (id) {
        const niche = this.$store.getters.niche;
        if (niche && niche.id == id) {
          this.select = niche;
        } else {
          this.$axios(
            `/admin/memorial-tablet-block-item/${id}?expand=tabletStatus,tabletBlock.tabletRegion`
          ).then((res) => {
            this.select = res;
          });
        }
      } else {
        this.$router.replace({ name: "TabletNicheOverview" });
      }
    },
    prev() {
      if (this.step > 1) {
        this.step -= 1;
      }
    },
    next() {
      const step = this.step;
      if (step == 1) {
        this.$refs.orderForm.submit().then((form) => {
          this.previewOrder({ ...form });
          this.step += 1;
        });
      } else if (step == 2) {
        this.$refs.previewForm.submit().then((form) => {
          this.insertOrder(form);
        });
      }
    },
    insertOrder(form) {
      if (this.confirmLoading) return;
      this.confirmLoading = true;
      const { data, detail } = this.order;
      detail.bill = form.bill;
      detail.processor = form.processor;
      data.order_info = JSON.stringify(detail);
      if (this.orderId) {
        // 续供订单 继续续供 永远传原始的订单id
        data.o_id = this.oldOrder?.o_id || this.orderId;
      }
      this.$axios({
        url: "/admin/memorial-tablet-order/add",
        method: "POST",
        data,
      })
        .then((res) => {
          if (res.error == 0) {
            this.$message.success("订单已创建");
            this.$router.push({
              name: "TabletOrderDetail",
              params: { id: res.order.id },
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .finally(() => {
          this.confirmLoading = false;
        });
    },
    getShowTime(year_count) {
      const order = this.oldOrder;
      const currentDate = order ? new Date(order.end_time * 1000) : new Date(); // 获取当前时间
      const twoYearsLater = new Date(currentDate); // 创建一个新的Date对象，将其设为当前时间
      twoYearsLater.setFullYear(currentDate.getFullYear() + year_count); // 设置年份为当前年份加2
      return `${currentDate.pattern("yyyy年M月d日")}-${twoYearsLater.pattern(
        "yyyy年M月d日"
      )}`;
    },
    previewOrder(form) {
      const data = omit(form, ["location", "bill", "processor"]);
      const { id, num, tabletBlock } = this.select;
      const blockId = tabletBlock.id;
      const regionId = tabletBlock?.tabletRegion?.id;
      const nichePrice = tabletBlock.price;
      const price = nichePrice; // 供奉年份默认10年，总价格默认等于龛位价格
      const province = form.location[0];
      const city = form.location[1];
      const district = form.location[2];
      const tablet_info = form.tablet_info; // 牌位信息
      const relationList = buddhism.getBuddhismTypeOptions(
        buddhism.buddhismRelationList
      );
      const relationTarget = relationList.find(
        (item) => item.key === tablet_info?.relation
      );
      const personList = tablet_info?.personList; // 牌位
      const posterityList = tablet_info?.posterityList; // 阳上

      data.province = province;
      data.city = city;
      data.district = district;
      data.num = num;
      data.mem_tablet_block_item_id = id;
      data.mem_tablet_block_id = blockId;
      data.mem_tablet_region_id = regionId;
      data.price = price;
      data.cat = 2; // 后台下单
      data.admin_id = getUserWxId();
      data.status = 1; // 已支付

      // 保持和小程序端一致
      const detail = {
        ...form,
        num,
        nichePrice,
        mem_tablet_block_item_id: id,
        mem_tablet_block_id: blockId,
        mem_tablet_region_id: regionId,
        showTime: this.getShowTime(form.year_count),
        price,
        bill: form.bill,
        processor: form.processor,
        showArea: `${tabletBlock?.tabletRegion?.name}-${tabletBlock?.name}-${num}`,
        ...getIntegerAndDecimal(price),
        itemList: [
          { label: "关系", value: relationTarget?.title },
          {
            label: "牌位",
            value: personList?.map((item) => item.name).join(","),
          },
          {
            label: "阳上",
            value: posterityList?.map((item) => item.name).join(","),
          },
          { label: "所在地区", value: `${province}-${city}-${district}` },
          { label: "详细地址", value: form.address },
          { label: "联系人", value: form.user_name },
          { label: "联系方式", value: form.mobile },
        ],
        tablet_info: JSON.stringify(tablet_info),
      };

      this.order = { data, detail };
    },
    cancel() {
      this.$router.go(-1);
    },
    removeSelect() {
      this.select = null;
      this.cancel();
    },
  },
};
</script>

<style lang="less">
.niche-create-order {
  display: flex;
  flex-direction: column;
  position: relative;
}
.order-create-area {
  flex: 1;
  min-height: 0;
  overflow: auto;
}
.create-order-button {
  padding: 14px 0;
  border-top: var(--border);
  width: 100%;
  background-color: @component-background;
  justify-content: center;
}
.order-niche-select {
  display: flex;
  align-items: center;
  position: absolute;
  left: 16px;
  bottom: 0;
  height: 60px;
}
.order-create-preview {
  padding: @padding-md;
}
.pay-info-piece {
  padding: 10px 20px;
  width: 480px;
}
.order-pay-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 0;
  font-size: 16px;
}
.pay-title-text {
  font-weight: 600;
}
.pay-info-item {
  display: flex;
  align-items: flex-start;
  margin-top: 8px;
  padding-left: 20px;
  &.text-right {
    .pay-info-value {
      text-align: right;
    }
  }
}
.pay-info-label {
  width: 5em;
}
.pay-info-value {
  flex: 1;
  min-width: 0;
}
.niche-select-info {
  display: flex;
  align-items: center;
  margin-left: 16px;
  padding: 6px 12px;
  height: 32px;
  border-radius: 4px;
  background-color: #ff8c00;
  color: @white;
  line-height: 1;
  font-size: 16px;
}
.niche-select-remove {
  margin-left: 8px;
  color: @white;
  cursor: pointer;
}
</style>
